
import { type FC, type ReactNode } from 'react'
import { Switch } from '@/components/ui/switch'

interface ToggleParamProps {
  /** Label text */
  label: string
  /** Current toggle state */
  checked: boolean
  /** Called when toggle state changes */
  onCheckedChange: (checked: boolean) => void
  /** Optional icon element rendered before the label */
  icon?: ReactNode
  /**
   * Layout variant:
   * - "simple": label + switch, no icon container (shader style)
   * - "icon": icon + label in flex container + switch (controlnet style)
   */
  variant?: 'simple' | 'icon'
}

export const ToggleParam: FC<ToggleParamProps> = ({
  label,
  checked,
  onCheckedChange,
  icon,
  variant = 'simple',
}) => {
  if (variant === 'icon') {
    return (
      <div className="flex items-center justify-between h-11 py-2 px-2">
        <div className="flex items-center gap-2 flex-1">
          {icon}
          <span className="text-sm">{label}</span>
        </div>
        <Switch checked={checked} onCheckedChange={onCheckedChange} />
      </div>
    )
  }

  // variant === 'simple'
  return (
    <div className="flex items-center gap-2 h-11 justify-center py-2 px-2">
      <span className="text-sm flex-1">{label}</span>
      <Switch checked={checked} onCheckedChange={onCheckedChange} />
    </div>
  )
}
